import styles from './EntitySuggestionPickerCell.module.scss';

import { Autocomplete, Box, Input } from '@mui/material';
import clsx from 'clsx';
import { useRef, useState } from 'react';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useEntitySuggestions } from '../../../../../../hooks/use-entity-suggestions';

type Props<T> = {
  entity: Entities;
  field: string;
  value: string;
  onChange: (res: { value: string; obj: T }) => void;
  isEditMode: boolean;
  startWithWildcard?: boolean;
  data?: T;
};

export function EntitySuggestionPickerCell<T>({
  field,
  entity,
  value,
  onChange,
  isEditMode = false,
  startWithWildcard = false,
  data,
}: Props<T>) {
  const [inputValue, setInputValue] = useState(value);
  const inputChanged = useRef(false);
  const suggestions = useEntitySuggestions<T>({
    field,
    entity,
    value: inputValue,
    startWithWildcard,
    data,
    searchWithEmptyTerm: true,
  });

  return (
    <Box width="100%">
      <Autocomplete
        freeSolo
        clearIcon={false}
        forcePopupIcon={false}
        options={suggestions}
        classes={{
          input: styles.innerInput,
        }}
        renderInput={(params) => {
          const { InputProps, inputProps } = params;

          return (
            <Input
              inputProps={inputProps}
              inputRef={InputProps.ref}
              className={clsx(styles.input, {
                [styles.inputEditMode]: isEditMode,
              })}
              disableUnderline
            />
          );
        }}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          return option?.value;
        }}
        value={value}
        inputValue={inputValue}
        onInputChange={(_, value) => {
          inputChanged.current = true;
          setInputValue(value);
        }}
        onChange={(_, value) => {
          inputChanged.current = false;
          if (typeof value === 'string') {
            onChange({ value, obj: null });
          } else {
            onChange(value);
          }
        }}
        onBlur={() => {
          if (inputChanged.current) onChange({ value: inputValue, obj: null });
        }}
      />
    </Box>
  );
}
